import { useCallback, useRef, useState } from 'react';

/** Keep the reviewed draft and selection until persistence confirms success. */
export function useVariableMutation() {
  const active = useRef(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const run = useCallback(async (action: () => void | Promise<void>, onSuccess?: () => void) => {
    if (active.current) return;
    active.current = true; setSaving(true); setError(null);
    try {
      const pending = action();
      if (pending) await pending;
      onSuccess?.();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Unable to save variables. Your changes have been kept.');
    } finally {
      active.current = false; setSaving(false);
    }
  }, []);
  return { saving, error, run };
}
